import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiSignup, apiMe, apiSession } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("dilli_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const me = await apiMe();
      setUser(me);
    } catch (e) {
      localStorage.removeItem("dilli_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const res = await apiLogin(email, password);
    localStorage.setItem("dilli_token", res.token);
    setUser(res.user);
    return res.user;
  };

  const signup = async (email, password) => {
    const res = await apiSignup(email, password);
    localStorage.setItem("dilli_token", res.token);
    setUser(res.user);
    return res.user;
  };

  const loginWithSession = async (sessionId) => {
    const res = await apiSession(sessionId);
    localStorage.setItem("dilli_token", res.token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem("dilli_token");
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const me = await apiMe();
      setUser(me);
      return me;
    } catch (e) {
      return null;
    }
  };

  const setPremium = (u) => setUser(u);

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, loginWithSession, logout, refreshUser, setPremium }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
